import React from "react";

function FarmAnimalsForm({ additionalAttributes, setAdditionalAttributes }) {
  const handleChange = (e) => {
    setAdditionalAttributes({
      ...additionalAttributes,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="farmAnimalsForm">
      {/* Heyvan növü */}
      <div>
        <h3>Heyvan Növü <span>*</span></h3>
        <select name="animalType" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="İnək">İnək</option>
          <option value="Qoyun">Qoyun</option>
          <option value="Keçi">Keçi</option>
          <option value="Camış">Camış</option>
          <option value="Dəvə">Dəvə</option>
          <option value="Başqa">Başqa</option>
        </select>
      </div>

      {/* Cins seçimi */}
      <div>
        <h3>Cins <span>*</span></h3>
        <select name="breed" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="Holstein">Holstein</option>
          <option value="Montbeliard">Montbeliard</option>
          <option value="Abşeron">Abşeron</option>
          <option value="Qarabağ">Qarabağ</option>
          <option value="Merino">Merino</option>
          <option value="Başqa">Başqa</option>
        </select>
      </div>

      {/* Yaş */}
      <div>
        <h3>Yaş ( İl ) <span>*</span></h3>
        <input type="number" name="age" min="0" max="25" required placeholder="Yaşı daxil edin" onChange={handleChange} />
      </div>

      {/* Cinsiyyət */}
      <div>
        <h3>Cinsiyyəti <span>*</span></h3>
        <select name="gender" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="Erkək">Erkək</option>
          <option value="Dişi">Dişi</option>
          <option value="Qısır">Qısır</option>
          <option value="Bala">Bala</option>
        </select>
      </div>

      {/* Çəki */}
      <div>
        <h3>Çəki (kg) <span>*</span></h3>
        <input type="number" name="weight" min="5" max="1500" required placeholder="Çəkini daxil edin" onChange={handleChange} />
      </div>

      {/* Süd verimi */}
      <div>
        <h3>Süd Verimi (litrlə) <span>*</span></h3>
        <input type="number" name="milkProduction" min="0" max="40" placeholder="Gündəlik süd verimi" onChange={handleChange} />
      </div>

      {/* Sağlamlıq vəziyyəti */}
      <div>
        <h3>Sağlamlıq vəziyyəti <span>*</span></h3>
        <select name="healthStatus" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="Sağlam">Sağlam</option>
          <option value="Müalicə olunmuş">Müalicə olunmuş</option>
          <option value="Xəstə">Xəstə</option>
          <option value="Peyvənd olunmuş">Peyvənd olunmuş</option>
        </select>
      </div>

      {/* Peyvəndlər */}
      <div>
        <h3>Peyvəndlər <span>*</span></h3>
        <select name="vaccinated" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="true">Bəli</option>
          <option value="false">Xeyr</option>
        </select>
      </div>

    </div>
  );
}

export default FarmAnimalsForm;
